import React, { useMemo, useState } from 'react';
import { isRoleFull } from '../domain/team';

// Ricerca giocatori.
//
// Correzioni rispetto a prima: normalizzazione degli accenti (cercare "Perisic"
// trovava nulla), limite ai risultati (digitare "a" renderizzava l'intero
// listone come nodi DOM), stato vuoto esplicito, e nessun accesso non protetto a
// `Cognome`, che nel feed remoto puo mancare e faceva sollevare la ricerca a
// ogni tasto premuto.

const MAX_RESULTS = 60;

function normalise(text) {
    return (text ?? '')
        .toString()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();
}

export default function PlayerSearch({
    players,
    excludedIds,
    onSelect,
    team,
    playersPerTeam,
    roleFilter,
    title = '🔍︎ Cerca Giocatore',
    // Quando la scelta non e' definitiva — la chiamata passa da una conferma —
    // il testo cercato resta: chi annulla ritrova la sua lista invece di
    // ridigitare il nome col turno che scorre.
    clearOnSelect = true,
}) {
    const [term, setTerm] = useState('');

    const results = useMemo(() => {
        const needle = normalise(term.trim());
        if (!needle) return [];
        const matches = [];
        for (const player of players) {
            if (excludedIds?.has(player.ID)) continue;
            if (roleFilter && player.Ruolo !== roleFilter) continue;
            if (
                normalise(player.Cognome).includes(needle) ||
                normalise(player['Nome Completo']).includes(needle)
            ) {
                matches.push(player);
                if (matches.length >= MAX_RESULTS) break;
            }
        }
        return matches;
    }, [term, players, excludedIds, roleFilter]);

    return (
        <div className="panel">
            <div className="panel-header">
                <h2 className="panel-title">{title}</h2>
            </div>
            <div className="panel-body search">
                <input
                type="text"
                className="input search-field"
                placeholder="Cerca per nome o cognome..."
                value={term}
                onChange={(event) => setTerm(event.target.value)}
            />
            <div className="search-results">
                {term.trim() && results.length === 0 && (
                    <div className="search-empty">Nessun giocatore trovato.</div>
                )}
                {results.map((player) => {
                    const roleFull =
                        playersPerTeam && isRoleFull(team, player.Ruolo, playersPerTeam);
                    return (
                        <button
                            key={player.ID}
                            type="button"
                            className="search-item"
                            onClick={() => {
                                onSelect(player);
                                if (clearOnSelect) setTerm('');
                            }}
                            disabled={roleFull}
                        >
                            <span className="search-item-name">{player['Nome Completo']}</span>
                            <span className="search-item-meta">
                                <span className="badge badge--role" data-role={player.Ruolo}>
                                    {player.Ruolo}
                                </span>
                                {player.Squadra}
                                {roleFull && <span className="badge badge--stop">Ruolo Pieno</span>}
                            </span>
                        </button>
                    );
                })}
                {results.length === MAX_RESULTS && (
                    <div className="search-empty">
                        Mostrati i primi {MAX_RESULTS} risultati: affina la ricerca.
                    </div>
                )}
                </div>
            </div>
        </div>
    );
}
